/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React, { Component } from 'react';
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber'
import { alert } from 'util/alert'
import sendPhoneVerification from 'controllers/user/sendPhoneVerification'

import './Modal.scss';

class ModalContent extends Component {
  constructor(props){
    super(props)

    this.state={
      params: {
        phone: '',
        pin: '',
        new_password: ''
      },
      message: 'sent-message',
      errorMsg: 'noShow',
      showNewPassword: false,
      resendCode: false,
      counterTime: 59,
      showPassword: false
    }

    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onChange = this.onChange.bind(this);

  }

  onPhoneChange(name) {
    return (value)=>{
      let {
        onFormChange,
      } = this.props;

      this.setState({
        params:{
          ...this.state.params,
          [name]: value,
        }
      }, ()=>{
        onFormChange(this.state)
      });
    }
  }

  onChange(name) {
    return (event)=>{
      let {
        onFormChange,
      } = this.props;

      this.setState({
        params:{
          ...this.state.params,
          [name]: event.target.value,
        }
      }, ()=>{
        onFormChange(this.state)
      });
    }
  }
  setVerificationCounter() {
    this.setState({ resendCode: true })
    this.timmer = setInterval(() => {
      if (this.state.counterTime > 0) {
        this.setState({ counterTime: (this.state.counterTime - 1) });
      } else {
        this.setState({ resendCode: false, counterTime: 59 });
        this.clearCounter();
      }
    }, 1000);
  }
  clearCounter() {
    clearInterval(this.timmer);
  }
  matchErrorMessages(errorMessage){
    switch(errorMessage){
      case 'username does not exist':
        return __('User does not exist', 'settings');
      case 'new password is less than 6 characters':
        return __('Password has to be at least 6 characters long', 'settings');
      case 'pin is wrong': 
      case 'please request the verification code first':
        return __('Invalid verification code', 'settings');
      case 'The verification code has expired': 
        return __('Verification code is expired', 'settings');
      default: 
        return __('Unexpected errors', 'settings') 
    }
  }
  render() {
    const { resendCode, counterTime, showPassword } = this.state;
    return (
      <div className='forgotpassword-modal-content'>
        <div className='container-fluid forgot-password-phone-input'>
          <div className='phone-input form-group'>
            {
              this.props.errorMessage && 
              <div className='showErrMsg'>{this.matchErrorMessages(this.props.errorMessage)}</div>
            }
            <label>{__('Please enter your phone number', 'appwrapper')}</label>
            <div className='phone-input2'>
              <ReactPhoneInput className='abc' defaultCountry={'ca'} value={this.state.params.phone} onChange={this.onPhoneChange('phone')} onlyCountries={['ca', 'us']} disableAreaCodes={true} />
                <button className='btn btn-primary verify-btn' onClick={()=>{
                  let phone = this.state.params.phone.country_code.trim() + this.state.params.phone.national_number.trim();
                  sendPhoneVerification({phone: phone, check_phone: 'sendIfUserExist'})
                  .then((res)=>{
                    if(res.result == 'success'){
                      this.setState({message: 'show-message', errorMsg: 'noShow'});
                      this.setVerificationCounter();
                    } else {
                      this.setState({errorMsg: 'showErrMsg', message: 'sent-message'})
                    }
                  })
                  .catch((err) => alert.warning(__('Please enter a valid phone number', 'teacher')))
                }} disabled={resendCode}>
                  {!resendCode? __("Send Verification Code", 'appwrapper'): __('Resent in {counterTime} s', 'appwrapper', {counterTime: counterTime})}
                </button>

            </div>
            <span className={this.state.message}>{__("Verification Code Sent", 'settings')}</span>
            <span className={this.state.errorMsg}>{__("User does not exist, please check the phone number", 'settings')}</span>
          </div>

          <div className='pin-input form-group'>
            <label>{__('Verification Code', 'appwrapper')}</label>
            <input type='number' placeholder={__('4 digits', 'settings')} className='form-control' onChange={this.onChange('pin')} />
          </div>

          <label>{__('Enter New Password', 'settings')}</label>
          <div className='password-input form-group'>
            <span className='password-icon'><i className="icon-lock"></i></span>
            <input className='form-control' type={showPassword? 'text': 'password'}  placeholder={__('At least 6 characters', 'settings')} onChange={this.onChange('new_password')} />
            <span className='toggle-text' onClick={()=>this.setState({showPassword: !showPassword})}>{showPassword? __('hide', 'settings'): __('show', 'settings')}</span>
          </div>

        </div>

      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/ForgotPassword/ModalContent.js